export default ({ params, errors } = window.FORM_DATA) => {
  const {
    fullName = null,
    email = null,
    bank = null,
    iban = null,
    terms = false,
    joinZahi = false
  } = params

  return {
    fullName,
    email,
    bank,
    iban,
    terms,
    joinZahi,
    errors,
    submitDisabled: false,
    profilePic: {
      '@upload:start' () {
        this.submitDisabled = true
      },

      '@upload:finish' () {
        this.submitDisabled = false
      }
    },

    onSubmit (event) {
      if (this.submitDisabled) {
        event.preventDefault()
      }
    }
  }
}
